import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ScrollTopButtonComponent } from '@shared/components/scroll-top-button/scroll-top-button.component';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { Store } from '@ngxs/store';
import { FetchUpdates } from '@store/catalogs/catalogs.actions';
import { CargoCatalogsService } from '@shared/services/cargo-catalogs.service';
import { MainInfoComponent } from './components/main-info/main-info.component';
import { CargoCalculationService } from './services/cargo-calculation.service';
import { CargoCharacteristicsComponent } from './components/cargo-characteristics/cargo-characteristics.component';
import { CargoPaymentsComponent } from './components/cargo-payments/cargo-payments.component';
import { OrdersComponent } from './components/orders/orders.component';

@Component({
  selector: 'app-cargo-calculation',
  standalone: true,
  imports: [
    ScrollTopButtonComponent,
    MainInfoComponent,
    CargoCharacteristicsComponent,
    CargoPaymentsComponent,
    OrdersComponent,
  ],
  providers: [CargoCalculationService],
  templateUrl: './cargo-calculation.component.html',
  styleUrl: './cargo-calculation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CargoCalculationComponent implements OnInit {
  constructor(
    private readonly cargoService: CargoCalculationService,
    private readonly route: ActivatedRoute,
    private readonly cargoCatalogsService: CargoCatalogsService,
    private readonly store: Store,
  ) {}

  ngOnInit() {
    this.store.dispatch(new FetchUpdates());
    this.cargoCatalogsService.preload();
    const id = this.route.snapshot.params.id as number;
    this.cargoService.setSelectedCargo(id).pipe(take(1)).subscribe();
    this.cargoService.fetchOrdersByCargoId(id).pipe(take(1)).subscribe();
  }
}
